<template>
  <div class="video-container" ref="videoContainer">
    <div class="circle-container" :style="{ borderColor: primaryColor }" ref="circleContainer">
      <div class="circle-container-img">
        <img
          class="lazyload"
          :src="profileImageUrl"
          :data-src="profileImageUrl"
        >
      </div>
    </div>
    <transition name="fade">
      <div
        ref="playerUsernameLabel"
        v-show="!!playerUsername && playerUsername.length > 0"
        class="player-username-label"
        :style="{ backgroundColor: primaryColor }"
      >
        {{ playerUsername }}
      </div>
    </transition>
    <transition name="pop-from-top">
      <div
        ref="answeredCheckMark"
        v-show="hasParticipantAnswered"
        class="video-check-mark"
        :style="{ color: primaryColor }"
      >
        <font-awesome-icon :icon="['fas', 'check-circle']" />
      </div>
    </transition>
    <transition name="pop-from-top">
      <div
        ref="votedCheckMark"
        v-show="hasParticipantVoted"
        class="video-check-mark"
        :style="{ color: primaryColor }"
      >
        <font-awesome-icon :icon="['fas', 'check-circle']" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'RemoteVideoComponent',
  props: {
    gameState: Object,
    participant: Object,   // participant.identity is the auth0UserId
  },
  data: () => ({
    primaryColor: '',
    secondaryColor: '',
    backgroundColor: '',
    profileImageUrl: ''
  }),
  computed: {
    playerUsername: function () {
      if ('playerUsernames' in this.gameState && 'playerUserIds' in this.gameState) {
        const playerIndex = this.gameState.playerUserIds.findIndex(userId => userId === this.participant.identity);
        return this.gameState.playerUsernames[playerIndex];
      }
      return '';
    },
    hasParticipantAnswered: function() {
      if ('hasAnswered' in this.participant) {
        return this.participant.hasAnswered;
      }
      return false;
    },
    hasParticipantVoted: function() {
      if ('hasVoted' in this.participant) {
        return this.participant.hasVoted;
      }
      return false;
    }
  },
  methods: {
    async getProfileImage() {
      switch(this.participant.identity) {
        case 'auth0_demo_remote_id_1':
          this.profileImageUrl = require('@/assets/landing/demo-remote-2.png');
          break;
        case 'auth0_demo_remote_id_2':
          this.profileImageUrl = require('@/assets/landing/demo-remote-1.png');
          break;
        case 'auth0_demo_remote_id_3':
          this.profileImageUrl = require('@/assets/landing/demo-remote-3.png');
          break;
        default:
          this.profileImageUrl = require('@/assets/landing/demo-remote-3.png');
      }
    },
    setPlayerColors () {
      const playerIndex = this.gameState.playerUserIds.findIndex(userId => userId == this.participant.identity);
      this.primaryColor = this.gameState.playerPrimaryColors[playerIndex];
      this.secondaryColor = this.gameState.playerSecondaryColors[playerIndex];
      this.backgroundColor = this.gameState.playerBackgroundColors[playerIndex];
    },
    resizeToSquare () {
      const circleDiameter = Math.min(this.$refs.videoContainer.clientWidth, this.$refs.videoContainer.clientHeight);
      const checkMarkDiameter = 0.2 * circleDiameter;
      const cornerRatio = 0.70710678;  // == 1 / Math.sqrt(2)
      this.$refs.circleContainer.style.height = circleDiameter + 'px';
      this.$refs.circleContainer.style.width = circleDiameter + 'px';
      this.$refs.answeredCheckMark.style.bottom = 'calc(50% - ' + cornerRatio * 0.5 * circleDiameter + 'px - ' + 0.5 * checkMarkDiameter + 'px)';
      this.$refs.answeredCheckMark.style.left = 'calc(50% - ' + cornerRatio * 0.5 * circleDiameter + 'px - ' + 0.5 * checkMarkDiameter + 'px)';
      this.$refs.answeredCheckMark.style.fontSize = checkMarkDiameter + 'px';
      this.$refs.votedCheckMark.style.bottom = 'calc(50% - ' + cornerRatio * 0.5 * circleDiameter + 'px - ' + 0.5 * checkMarkDiameter + 'px)';
      this.$refs.votedCheckMark.style.left = 'calc(50% - ' + cornerRatio * 0.5 * circleDiameter + 'px - ' + 0.5 * checkMarkDiameter + 'px)';
      this.$refs.votedCheckMark.style.fontSize = checkMarkDiameter + 'px';
      this.$refs.playerUsernameLabel.style.bottom = 'calc(50% - ' + 0.5 * circleDiameter + 'px)';
      this.$refs.playerUsernameLabel.style.fontSize = 0.5 * checkMarkDiameter + 'px';
    }
  },
  watch: {
    gameState: function () {
      this.setPlayerColors();
    },
    hasParticipantAnswered: function(value) {
      if (value) {
        this.$emit('play-sound-effect', 'player-submitted-prompts-' + this.participant.joinedIndex);
      }
    },
    hasParticipantVoted: function(value) {
      if (value) {
        this.$emit('play-sound-effect', 'player-submitted-prompts-' + this.participant.joinedIndex);
      }
    }
  },
  created: async function () {
    await this.getProfileImage();
  },
  mounted: async function() {
    // console.log('particiant:', this.participant);
    this.$nextTick(function() {
      this.resizeToSquare();
      window.addEventListener('resize', this.resizeToSquare);
      this.setPlayerColors();
      this.$emit('play-sound-effect', 'player-joined-lobby-' + this.participant.joinedIndex);
    });
  },
  destroyed: function() {
    window.removeEventListener('resize', this.resizeToSquare);
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/video-component-styles.scss';
</style>
